import NavBar from "./components/NavBar/NavBar";
import Footer from './components/Footer/Footer'
import React, { useEffect, useState } from 'react';
import About from './components/About/About';
import Index from './components/Index/Index';
import Contact from './components/Contact/Contact'
import Map from "./components/Map/Map"
import classes from "./App.module.css"
import { StateContext } from './context/StateContext'
import HomePage from "./components/HomePage/HomePage";
import iconicTaxa from './iconictaxa.json'
import { SANITY_URL } from './sanityApi'
import { BrowserRouter, Routes, Route } from "react-router-dom";

//To do

// inat resources
// https://github.com/jumear/stirfry


function App() {

  const [month, setMonth] = useState(0)
  const [location, setLocation] = useState('initLocation')
  const [locations, setLocations] = useState(undefined)
  // fetch the content
  useEffect(() => {
    fetch(SANITY_URL)
      .then((res) => res.json())
      .then(({ result }) => {
        let locs = result.map((x) => {
          return({
            title: x.name,
            slug: x.slug.current,
            featured: x.isFeatured, 
            bbox: {
              nelat: x.neLocation.lat,
              nelng: x.neLocation.lng,
              swlat: x.swLocation.lat,
              swlng: x.swLocation.lng
            }
        })

        })
        setLocations(locs)
        setLocation(locs[0])
      })
      .catch((err) => console.error(err))
  }
    , []
  )

if(!locations) return(<div className={classes.loadingImage}><img src='/img/loading.gif' alt='Loading...'/></div>) 

  const AboutPage = () => {
    return (
      <>
        <Map bbox={location.bbox} />
        <About location={location} />
        <Footer />
      </>
    )
  }

  const IndexPage = () => {
    return (
      <>
        <Index locations={locations}/>
        <Footer />
      </>
    )
  }

  const ContactPage = () => {
    return (
      <>
        <Contact />
        <Footer />
      </>
    )
  }
  
  console.log({location})
  if (!location) {
    return (
      <IndexPage />
      )
    }
  return (
    <div className={classes.App}>
      <StateContext>
        <BrowserRouter>
          {location === 'initLocation' ?
            null :
            <NavBar month={month} location={location} setMonth={setMonth} title={location.title + " Field Guide"} />}
          <Routes>
            <Route path='/' element={<IndexPage />} />
            <Route path=':loc' element={
              <HomePage
                iconicTaxa={iconicTaxa}
                month={month}
                setMonth={setMonth}
                location={location}
                setLocation={setLocation}
                locations={locations}
              />
            } />
            <Route path=':loc/about' element={<AboutPage />} />
            <Route path=':loc/contact' element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
      </StateContext>
    </div>
  );
}

export default App;
